import * as z from "zod/v4";

export enum ReturnMethodType {
  PICKUP = "Pickup",
  GREEN = "Green",
  DROP_OFF = "Drop Off",
  SHIPMENT = "Shipment",
  ERROR = "Error",
}

export const ReturnMethodZodSchema = z.looseObject({
  type: z.enum(ReturnMethodType),
});

export interface ReturnMethod {
  type: ReturnMethodType;
}
